module.exports = __webpack_public_path__ + "media/images/flags/16/Uganda-3b4b5281bdd10ea0b0dacfc270b017c4.png";